import * as React from "react";
import Component from "../../AbstractComponent";
import { connect } from "react-redux";
import Constants from "../../../Action/Constants";

import { TableComponent } from "../../Partials/Table/TableComponent";
import { EventInterface } from "../../../Entity/Entities/Event/EventInterface";
import { PromptDialog } from "../../Partials/Dialog/PromptDialog";
import { TabsComponent } from "./TabsComponent";

import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Card from '@material-ui/core/Card';
import IconButton from '@material-ui/core/IconButton';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TextField from "../../Partials/Material/TextField";
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';

class Notes extends Component {
  protected paginatorPath: string = !!this.props.app.notesFilterSearchState ?
                                    `Notes_${this.props.app.notesFilterState}_${this.props.app.notesFilterSearchState}` :
                                    `Notes_${this.props.app.notesFilterState}`;
  protected userId: number = this.props.app.session.user.id;
  protected searchTimer;

  public state = {
    isDeleteNotePopupOpen: false,
    currentNote: null,
    notes: [],
    openNotes: [],
    notesCount: 0,
    openNotesCount: 0,
    filter: this.props.app.notesFilterState,
    isSaving: false,
    anchorEl: null,
    isFetching: true,
    filterValue: this.props.app.notesFilterSearchState,
    searchInProgress: false
  };

  constructor(public props) {
    super(props);
  }

  public componentWillMount() {
    this.fetchFirstOpenNotes();
    this.fetchFirstAllNotes();
  }

  public componentWillUnmount() {
    clearTimeout(this.searchTimer);
  }

  public fetchFirstAllNotes = () => {
    const paginationAmount = !!this.props.app.paginator && !!this.props.app.paginator[this.paginatorPath] ?
      this.props.app.paginator[this.paginatorPath]: this.props.app.defaultPaginationAmount;

    const payload: any = {
      offset: 0,
      limit: paginationAmount,
      filterValue: this.state.filterValue,
      eventTypeId: 17,
      removed: 0,
      isSnoozed: 0
    };

    this.props.dispatch({
      type: Constants.GLOBAL_EVENTS_SAVE_LIST,
      payload: {
        ...payload
      },
      onSuccess: (data) => this.setState({
        searchInProgress: false,
        notes: data.events,
        notesCount: data.count,
        isFetching: false
      }),
      onError: () => {
        this.setState({
          searchInProgress: false,
          isFetching: false
        });
      }
    });
  }

  public fetchFirstOpenNotes = () => {
    const paginationAmount = !!this.props.app.paginator && !!this.props.app.paginator[this.paginatorPath] ?
      this.props.app.paginator[this.paginatorPath]: this.props.app.defaultPaginationAmount;

    const payload: any = {
      offset: 0,
      limit: paginationAmount,
      filterValue: this.state.filterValue,
      eventTypeId: 17,
      removed: 0,
      reacted: 0,
      isSnoozed: 0
    };

    this.props.dispatch({
      type: Constants.GLOBAL_EVENTS_SAVE_LIST,
      payload: {
        ...payload
      },
      onSuccess: (data) => this.setState({
        searchInProgress: false,
        openNotes: data.events,
        openNotesCount: data.count,
        isFetching: false
      }),
      onError: () => {
        this.setState({
          searchInProgress: false,
          isFetching: false
        });
      }
    });
  }

  public fetchFilterAllNotes = () => {
    this.props.dispatch({
      type: Constants.GLOBAL_EVENTS_SAVE_LIST,
      payload: {
        filterValue: this.state.filterValue,
        eventTypeId: 17,
        removed: 0,
        isSnoozed: 0
      },
      onSuccess: data => {
        this.setState({
          notes: data.events,
          notesCount: data.count,
          isFetching: false
        })
      }
    })
  }

  public fetchFilterOpenNotes = () => {
    this.props.dispatch({
      type: Constants.GLOBAL_EVENTS_SAVE_LIST,
      payload: {
        filterValue: this.state.filterValue,
        eventTypeId: 17,
        removed: 0,
        reacted: 0,
        isSnoozed: 0
      },
      onSuccess: data => {
        this.setState({
          openNotes: data.events,
          openNotesCount: data.count,
          isFetching: false
        })
      }
    })
  }

  public clearFilterAllNotes = () => {
    this.props.dispatch({
      type: Constants.NOTES_FILTER_SEARCH_UPDATE_STATE,
      payload: {
        filter: ""
      }
    });

    this.setState({
      filterValue: ""
    }, this.fetchFirstAllNotes);
  }

  public clearFilterOpenNotes = () => {
    this.props.dispatch({
      type: Constants.NOTES_FILTER_SEARCH_UPDATE_STATE,
      payload: {
        filter: ""
      }
    });

    this.setState({
      filterValue: ""
    }, this.fetchFirstOpenNotes);
  }

  public setFilterValue = (event): any => {
    clearTimeout(this.searchTimer);

    this.setState({
      filterValue: event.target.value
    } ,() => {
      if (this.state.filterValue === "") {
        if (this.state.filter === "all") {
          this.clearFilterAllNotes();
        } else {
          this.clearFilterOpenNotes();
        }
      }

      this.searchTimer = setTimeout(() => {
        this.setState({
          searchInProgress: true
        }, () => {
          this.paginatorPath = !!this.state.filterValue ?
                              `Notes_${this.state.filter}_${this.state.filterValue}` :
                              `Notes_${this.state.filter}`;

          this.props.dispatch({
            type: Constants.NOTES_FILTER_SEARCH_UPDATE_STATE,
            payload: {
              filter: this.state.filterValue
            }
          });

          if (this.state.filter === "all") {
            this.fetchFirstAllNotes();
          } else {
            this.fetchFirstOpenNotes();
          }
        });
      }, this.props.app?.listSearchTimeout);
    });
  }

  public fetchNotes = () => {
    if (this.state.filter === "all") {
      const payload: any = {
        offset: !!this.state.notes ?  this.state.notes.length : 0,
        limit: this.props.app.defaultPaginationAmount,
        filterValue: this.state.filterValue,
        eventTypeId: 17,
        removed: 0,
        isSnoozed: 0
      };

      this.props.dispatch({
        type: Constants.GLOBAL_EVENTS_SAVE_LIST,
        payload: {
          ...payload
        },
        onSuccess: (data) => {
          const notesArr: EventInterface[] = !!this.state.notes ?
                                                  [...this.state.notes, ...data.events] : [...data.events];

          this.setState({
            notes: notesArr,
            notesCount: data.count,
            isFetching: false
          });
        }
      });
    } else if (this.state.filter === "open") {
      const payload: any = {
        offset: !!this.state.openNotes ?  this.state.openNotes.length : 0,
        limit: this.props.app.defaultPaginationAmount,
        filterValue: this.state.filterValue,
        eventTypeId: 17,
        removed: 0,
        reacted: 0,
        isSnoozed: 0
      };

      this.props.dispatch({
        type: Constants.GLOBAL_EVENTS_SAVE_LIST,
        payload: {
          ...payload
        },
        onSuccess: (data) => {
          const openNotesArr: EventInterface[] = !!this.state.openNotes ?
                                          [...this.state.openNotes, ...data.events] : [...data.events];

          this.setState({
            openNotes: openNotesArr,
            openNotesCount: data.count,
            isFetching: false
          });
        }
      });
    }
  }

  public changeFilter = (event: any): void => {
    const filter: string = event.target.value;

    this.setState({
      filter: filter
    }, () => {
      this.paginatorPath = `Notes_${filter}`;

      this.props.dispatch({
        type: Constants.NOTES_FILTER_UPDATE_STATE,
        payload: {
          filter: filter
        }
      });

      if (filter === "all") {
        if (this.state.filterValue) {
          this.fetchFilterAllNotes();
        } else {
          this.fetchFirstAllNotes();
        }
      } else if (filter === "open") {
        if (this.state.filterValue) {
          this.fetchFilterOpenNotes();
        } else {
          this.fetchFirstOpenNotes();
        }
      }
    });
  }

  public getAmountsOfFilteredNotes = (filter: string): number => {
    switch (filter) {
      case "all":
        return this.state.notesCount;
      case "open":
        return this.state.openNotesCount;
      default:
        return;
    }
  }

  public getFilteredNotes = (filter: string): EventInterface[] => {
    switch (filter) {
      case "all":
        return this.state.notes;

      case "open":
        return this.state.openNotes;
      default:
        return;
    }
  }

  public deleteNote = (note: EventInterface) => {
    this.props.dispatch({
      type: Constants.GLOBAL_EVENT_DELETE_START,
      payload: {
        event: note
      },
      onSuccess: () => {
        this.fetchFirstAllNotes();
        this.fetchFirstOpenNotes();
      }
    });
  }

  protected openMenu = (event: any, note: EventInterface): void => {
    this.setState({
      currentNote: note,
      anchorEl: event.currentTarget
    });
  }

  protected closeMenu = (): void => {
    this.setState({
      anchorEl: null
    });
  }

  public getNotes = () => {
    return this.getFilteredNotes(this.state.filter)
      .map((note: EventInterface, index: number) => {
        return (
          <TableRow
            hover
            key={index}
            className={`clickable-entity`}
            onClick={() => this.redirect(`/app/note/update/${note.id}`)}
          >
            <TableCell style={{width: "24px", paddingLeft: "24px", paddingRight: "0px"}}>
              <div style={{display: "flex", alignItems: "center", justifyContent: "center", paddingTop: "4px"}}>
                <div
                  className="icon icon-ic-memo"
                  style={{
                    color: "#00BCD4"
                  }}
                >
                </div>
              </div>
            </TableCell>
            <TableCell style={{width: "15%"}}>{note.createdAt && this.formatter.formatDate(new Date(note.createdAt))}</TableCell>
            <TableCell style={{width: "30%"}}>{note.object && note.object.listDisplayName}</TableCell>
            <TableCell style={{width: "45%"}}>{note.content && note.content.note}</TableCell>
            <TableCell
              onClick={e => {
                e.stopPropagation();
              }}
            >
              <div>
                <IconButton
                  onClick={e => this.openMenu(e, note)}
                >
                  <div className="icon icon-ic-more-vert"></div>
                </IconButton>
                <Menu
                  id="simple-menu"
                  anchorEl={this.state.anchorEl}
                  open={Boolean(this.state.anchorEl) && this.state.currentNote && this.state.currentNote.id === note.id}
                  onClose={this.closeMenu}
                  disableAutoFocusItem={true}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center"
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left"
                  }}
                  getContentAnchorEl={null}
                >
                  <MenuItem
                    onClick={() => this.redirect(`/app/note/update/${note.id}`)}
                  >
                    <ListItemIcon><div className="icon icon-ic-edit aligned"></div></ListItemIcon>
                    <ListItemText>{this.trans("menuitem-open")}</ListItemText>
                  </MenuItem>
                  <MenuItem
                    onClick={() => this.setState({isDeleteNotePopupOpen: true, anchorEl: null})}
                  >
                    <ListItemIcon><div className="icon icon-ic-remove aligned"></div></ListItemIcon>
                    <ListItemText>{this.trans("menuitem-delete")}</ListItemText>
                  </MenuItem>
                </Menu>
              </div>
            </TableCell>
          </TableRow>
        );
      });
  }

  public render() {
    return (
      <div className="state-app">
        <div className={`box box-full component-dashboard has-general-page-header with-tabs ${this.props.app?.settings?.user?.launchPanelState ? "with-launchpanel" : ""}`}>
          <div className="component-header no-paddings">
            <h1>{this.trans("title-dashboard")}</h1>
            <TabsComponent
              activeTab={9}
              {...this.props}
            />
          </div>

          <div className="component-wrapper no-margin-top">
            <Card className="card no-padding">
              <div className="label-container"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  height: "48px",
                  maxHeight: "48px"
                }}
              >
                <h3 className="card-title">
                  {this.trans("page/dashboard-tab/notes")}
                </h3>
                <div className="button-container">
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => this.redirect(`/app/note/create`)}
                  >
                    {this.trans("new-note")}
                  </Button>
                </div>
              </div>

              <div>
                <div>
                  <div
                    className="list-filters-wrapper"
                    style={{justifyContent: "flex-end"}}
                  >
                    <div className="table-filterer">
                      <TextField
                        autoComplete="off"
                        type="text"
                        style={{color: "rgb(0, 188, 212)"}}
                        label={this.trans("label-search")}
                        value={this.state.filterValue}
                        onChange={this.setFilterValue}
                        variant="standard"
                        error={false}
                      />
                      { this.state.filterValue !== "" &&
                        <div className="icon icon-ic-close clear-button clear-button-search" onClick={this.state.filter === "all" ? this.clearFilterAllNotes : this.clearFilterOpenNotes}></div>
                      }
                      { 
                        this.state.searchInProgress &&
                        <div className="search-loader">
                          <CircularProgress size={20} />
                        </div>
                      }
                    </div>
                  </div>
                </div>
                <TableComponent
                  {...this.props}
                  paginator={{
                    name: this.paginatorPath,
                    path: this.props.app.paginator
                  }}
                  className="listing-table tasks-listing-table with-first-border"
                  headers={[
                    "", this.trans("date"), this.trans("object"), this.trans("note"), ""
                  ]}
                  rows={this.getNotes()}
                  rowsLength={this.getAmountsOfFilteredNotes(this.state.filter)}
                  subtitle={this.trans("title-no-notes-to-list")}
                  fetch={this.fetchNotes}
                  isFetching={this.state.isFetching}
                  filtering={this.state.filterValue.length > 0}
                />
              </div>
            </Card>
          </div>
        </div>

        <PromptDialog
          {...this.props}
          title={this.trans("delete-note")}
          content={this.trans("you-are-about-to-delete-note")}
          negativeButtonLabel={this.trans("button-cancel")}
          positiveButtonLabel={this.trans("button-remove")}
          openLeavePrompt={this.state.isDeleteNotePopupOpen}
          prioritizeClosing={true}
          onDiscard={() => { this.setState({ isDeleteNotePopupOpen: false }); }}
          onSave={() => { this.setState({ isDeleteNotePopupOpen: false }); this.deleteNote(this.state.currentNote) }}
          positiveButtonStyle={{backgroundColor:"red"}}
          hideCross={true}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
    events: state.events,
    units: state.units,
    component: state.notes,
    globalTypes: state.globalTypes
  };
};

export default connect(mapStateToProps)(Notes);
